import React, { PureComponent } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { compose } from 'redux';
import {customisedIntlFormatMessage} from '../../utils/helpers';

import Accordion from '../Accordion';

const localMessages = defineMessages({
  accordionClassification: {
    id: 'schoolinfo.accordionClassification',
    defaultMessage: 'Classification',
    description: 'Accordion label for classification',
  },
  accordionCoLocatedSchools: {
    id: 'schoolinfo.accordionCoLocatedSchools',
    defaultMessage: 'Co-located Schools',
    description: 'Accordion label for Co-located schools',
  },
  accordionClassRatio: {
    id: 'schoolinfo.accordionClassRatios',
    defaultMessage: 'Class/Program Ratio(s)',
    description: 'Accordion label for class ratios',
  },
  accordionBridge: {
    id: 'schoolinfo.accordionBridge',
    defaultMessage: 'Bridge',
    description: 'Accordion label for Bridge',
  },
  accordionAssessmentType: {
    id: 'schoolinfo.accordionAssessmentType',
    defaultMessage: 'Assessment Type',
    description: 'Accordion label for Assessment Type',
  },
  helpTextBridge: {
    id: 'schoolinfo.helpTextBridge',
    defaultMessage: 'Grade span',
    description: 'Accordion help text for Bridge',
  },
  helpTextClassProgramRatio: {
    id: 'schoolinfo.helpTextClassProgramRatio',
    defaultMessage: 'Ratio of students to teachers to paraprofessionals',
    description: 'Accordion help text for ClassProgramRatio',
  },
});

class SchoolAccordion extends PureComponent {
  getColocatedschools = () => {
    const { co_located_schools, style } = this.props;
    if (!co_located_schools || co_located_schools.length === 0) {
      return null;
    }
    const coLocatedSchoolsList = co_located_schools.map((coLocatedSchoolItem, index) => (
      <li key={coLocatedSchoolItem.name + '-' + index}>{coLocatedSchoolItem.name}</li>
    ));
    return <ul className={style.disc}>{coLocatedSchoolsList}</ul>;
  };

  getClassification = () => {
    const { classification, style } = this.props;
    if (classification.length == 0)
    {
      return null;
    }
    const classificationList = classification.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{classificationList}</ul>;
  };

  getclassProgramRatio = () => {
    const { class_program_ratio, style } = this.props;
    if (class_program_ratio.length == 0)
    {
      return null;
    }

    const classProgramRatioList = class_program_ratio.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{classProgramRatioList}</ul>;
  };

  getBridge = () => {
    const { bridge, style } = this.props;
    if (bridge.length == 0)
    {
      return null;
    }
  
    const bridgeList = bridge.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{bridgeList}</ul>;
  };

  getAssessmentType = () => {
    const { assessment_type, style } = this.props;
    if (assessment_type.length == 0)
    {
      return null;
    }

    const assessmentTypeList = assessment_type.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{assessmentTypeList}</ul>;
  };

  render() {
    const { accordionAnalyticsClick, intl, style } = this.props;
    return (
      <>
        {this.getColocatedschools() && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionCoLocatedSchools)}  analytics={accordionAnalyticsClick}>
            <div className={style.schoolDataWrapper}>
              {this.getColocatedschools()}
            </div>
        </Accordion>}

        {this.getClassification() && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionClassification)}  analytics={accordionAnalyticsClick} >
            <div className={style.schoolDataWrapper}>
              {this.getClassification()}
            </div>
        </Accordion>}

        {this.getclassProgramRatio() && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionClassRatio)} title={customisedIntlFormatMessage(intl, localMessages.helpTextClassProgramRatio)} analytics={accordionAnalyticsClick} >
            <div className={style.schoolDataWrapper}>
              {this.getclassProgramRatio()}
            </div>
        </Accordion>}

        {this.getBridge() && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionBridge)}  title={customisedIntlFormatMessage(intl, localMessages.helpTextBridge)} analytics={accordionAnalyticsClick} >
          <div className={style.schoolDataWrapper}>
            {this.getBridge()}
          </div>
        </Accordion>}

        {this.getAssessmentType() && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAssessmentType)} analytics={accordionAnalyticsClick}>
            <div className={style.schoolDataWrapper}>
              {this.getAssessmentType()}
            </div>
        </Accordion>}
      </>
    );
  }
}

export { SchoolAccordion};
export default compose(
  injectIntl,
)(SchoolAccordion);
